import { DmsLinkEntityType, EntityLookupItem } from './entity-lookup.types';

/** Picker-Output. Andere Phasen (B) konsumieren exakt dieses Interface. */
export interface EntityTreePickerSelection {
  readonly entityType: DmsLinkEntityType;
  readonly entityId: string;
  readonly label: string;
  readonly parentIds?: Record<string, string>;
  /** Leistungsphasennummer (1–9); nur für entityType 'leistungsphase' gesetzt. */
  readonly lph?: number;
}

/** Tabs des Pickers (Spec §5). */
export type PickerTab = 'projektbaum' | 'organisation' | 'ansprechpartner' | 'bestandsknoten';

/** Die im Projekt-Baum cross-durchsuchbaren Typen (Spec §5 „Cross-Typ-Suche"). */
export const PROJEKTBAUM_TYPES: readonly DmsLinkEntityType[] = [
  'projekt',
  'vertrag',
  'leistungsbild',
  'leistungsphase',
  'teilleistung',
];

/** Direkter Kind-Typ je Baum-Knoten-Typ; null = Blatt (Spec §5 „typgetrieben"). */
export const CHILD_TYPE_OF: Partial<Record<DmsLinkEntityType, DmsLinkEntityType | null>> = {
  projekt: 'vertrag',
  vertrag: 'leistungsbild',
  leistungsbild: 'leistungsphase',
  leistungsphase: 'teilleistung',
  teilleistung: null,
};

/** Ein Baum-Knoten im Lazy-Drilldown. */
export interface TreeNode {
  readonly type: DmsLinkEntityType;
  readonly item: EntityLookupItem;
  expanded: boolean;
  loading: boolean;
  error: boolean;
  children: TreeNode[] | null; // null = noch nicht geladen
}

const TYPE_LABELS: Record<DmsLinkEntityType, string> = {
  projekt: 'Projekt',
  vertrag: 'Vertrag',
  leistungsbild: 'Leistungsbild',
  leistungsphase: 'Leistungsphase',
  teilleistung: 'Teilleistung',
  organisation: 'Organisation',
  ansprechpartner: 'Ansprechpartner',
  bestandsknoten: 'Bestandsknoten',
  stundennachweis: 'Stundennachweis',
};

/**
 * Zentrale Label-Map (Spec §4): konkretes Label oder Fallback „Eintrag".
 * KANONISCHE Single-Source (siehe „Cross-Phase Consistency"): akzeptiert auch
 * null/undefined (z. B. globaler Lösch-Kontext in Phase C ohne Bezugstyp) → „Eintrag".
 */
export function entityTypeLabel(type: DmsLinkEntityType | null | undefined): string {
  return type ? (TYPE_LABELS[type] ?? 'Eintrag') : 'Eintrag';
}
